import { useAppSelector } from '@redux/hooks';
import { scrollToElement } from '@shared/helpers';
import classNames from 'classnames';
import { FC, useCallback } from 'react';
import { getShortFeatures } from '../../../module/helper/getShortFeatures';
import { getProductSpecs } from '../../../module/selectors/getProductSpecs';
import { getProductType } from '../../../module/selectors/getProductType';
import { ElementIdTab } from '../../../module/types/productSchema';
import { ProductSpec } from './ProductSpec';
import { ShortProductSpecsTypeProps } from './TypeProps';

import styles from './ShortProductSpecs.module.scss';

export const ShortProductSpecs: FC<ShortProductSpecsTypeProps> = ({ className }) => {
  const productSpecs = useAppSelector(getProductSpecs);
  const part = useAppSelector(getProductType);
  const handlerShowFullProductSpecs = useCallback(() => {
    setTimeout(() => {
      scrollToElement(document.getElementById(ElementIdTab.TabProductSpecs), {
        top: 150,
      });
    }, 300);
  }, []);
  return (
    <div className={classNames(styles.WrapperProductSpecs, className)}>
      <div className={styles.Title}>Характеристики</div>
      <div className={styles.Table}>
        {getShortFeatures(part, productSpecs).map(spec => (
          <ProductSpec key={spec.title} part={part} {...spec} isShort />
        ))}
      </div>
      <div onClick={handlerShowFullProductSpecs} className={styles.LinkFullProductSpecs + ' ProductCardProperties_ButtonShowAllLabel'}>
        Все характеристики
      </div>
    </div>
  );
};
